import { render, staticRenderFns } from "./ExternalEMail.vue?vue&type=template&id=aa87baf8&"
import script from "./ExternalEMail.vue?vue&type=script&lang=js&"
export * from "./ExternalEMail.vue?vue&type=script&lang=js&"
import style0 from "./ExternalEMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports